import { render, staticRenderFns } from "./NotAllowedList.vue?vue&type=template&id=14e72c4f&"
import script from "./NotAllowedList.vue?vue&type=script&lang=js&"
export * from "./NotAllowedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports